module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "anniversary-container swiper"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-wrapper"
  }, [_c('van-loading')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "swiper-wrapper"
  }, [_c('page-start', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }), _vm._v(" "), _c('page-roadmap', {
    attrs: {
      "swiper": _vm.swiper
    }
  }), _vm._v(" "), _c('page-meet', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }), _vm._v(" "), (_vm.data && _vm.data.amount) ? _c('page-contract', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.amount && _vm.data.firstContractDate) ? _c('page-contract-first', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.amount && _vm.data.yearDiff) ? _c('page-contract-last', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.campaignTimes) ? _c('page-activities', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data && _vm.data.registrationDate) ? _c('page-content', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('page-coupon', {
    attrs: {
      "swiper": _vm.swiper,
      "data": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), _c('page-key-words', {
    attrs: {
      "swiper": _vm.swiper
    }
  }), _vm._v(" "), _c('page-key-words-reslut', {
    attrs: {
      "swiper": _vm.swiper
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5421dd64","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Activities/AnnivesaryCoupon/Anniversary.vue
// module id = 1637
// module chunks = 8